
export class GrupoDto {
	nombre: string;
	activo: boolean;
	alerta: boolean;
	whatsapp: boolean;
	sms: boolean;
	push: boolean;
	email: boolean;
}
